var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAffiliatesmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m10.2 4.57.36.36c.28.28.44.66.44 1.06a1.49 1.49 0 0 1-.45 1.08l-.35.36a.75.75 0 0 0-.22.53v.51c0 .83-.68 1.5-1.5 1.5h-.52c-.2 0-.4.09-.53.23l-.36.36a1.51 1.51 0 0 1-2.13 0l-.37-.36a.75.75 0 0 0-.53-.22h-.51a1.5 1.5 0 0 1-1.5-1.5v-.52c0-.2-.09-.4-.23-.54l-.36-.35a1.51 1.51 0 0 1 0-2.13l.36-.37a.75.75 0 0 0 .22-.53v-.51c0-.83.68-1.5 1.5-1.5h.52c.2 0 .4-.09.53-.23l.36-.36a1.5 1.5 0 0 1 2.13 0l.37.36c.14.14.33.22.53.22h.51c.83 0 1.5.68 1.5 1.5v.52c0 .2.09.4.23.53ZM4.71 7.72c.12 0 .23-.04.31-.13L7.6 5.02a.44.44 0 0 0 0-.62.44.44 0 0 0-.61 0L4.4 6.97a.44.44 0 0 0 .3.75Zm2.14-.44a.44.44 0 1 0 .87 0 .44.44 0 0 0-.87 0Zm-2.13-3c.24 0 .43.2.43.43 0 .25-.2.44-.43.44a.44.44 0 0 1-.44-.44c0-.24.2-.43.44-.43Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAffiliatesmall);
export default __webpack_public_path__ + "static/media/affiliate.small.0b8ff8041c0f545be12c02f1b2017a48.svg";
export { ForwardRef as ReactComponent };